import React from 'react';
import SelectSort from './SelectSort';
import Css from './SortItems.module.css';
import Skeleton from '@mui/material/Skeleton';

const SortItems = (props) => {

  return (
    <div className={Css.content}>

      {props.isFetching ? <Skeleton width={78} height={31} />
        :
        <div className={Css.countItems}>
          {props.countItems}
        </div>
      }
      <SelectSort {...props} />
    </div>
  );
}

export default SortItems;